import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router';
import Router from './Router';
import { AuthProvider } from "react-oidc-context";

const BASE_URL = process.env.REACT_APP_URL;

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_jMT4TcPYV",
  client_id: "3d810ebiahqdulnov1u2ktvvj5",
  redirect_uri: BASE_URL,
  response_type: "code",
  scope: "email openid phone",
};
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <RouterProvider router={Router} />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
